<template>
	<router-link :to="href" class="py-3 px-9 inline-block rounded-lg text-center font-medium text-sm transition-colors"
		:class="classes">
		<slot></slot>
	</router-link>
</template>

<script>
export default {
	props: ['href', 'buttonStyle'],
	computed: {
		classes: function() {
			switch (this.buttonStyle) {
				case 'primary':
					return ' bg-primary text-secondary hover:text-white hover:bg-secondary'
				case 'secondary':
					return 'bg-secondary text-white  hover:bg-secondary/80'
					case 'grey':
					return 'bg-[#F4F4F4] text-dark-4  hover:bg-secondary/80 hover:text-white'
				default:
					return 'bg-transparent border-secondary text-secondary py-2'
			}
		}
	}
}
</script>